import { NavigationGuardNext, Route, RouteConfig } from 'vue-router'

const metaConfig = { config: true, auth: true }

const routes = [
	{
		path: '/settings/addons',
		name: 'config.addons',
		component: () => import('@/modules/addons/views/AddonsIndex.vue'),
		meta: { ...metaConfig, permissions: [{ action: 'read', resource: 'Addon' }] },
	},
	{
		path: '/settings/addons/:id',
		name: 'config.visualizeAddon',
		component: () => import('@/modules/addons/views/AddonDetail.vue'),
		beforeEnter: (to: Route, _: Route, next: NavigationGuardNext) => {
			if (to.params && to.params.id) {
				next()
			} else {
				next({ name: 'config.addons' })
			}
		},
		meta: {
			...metaConfig,
			permissions: [
				{ action: 'read', resource: 'Addon' },
				{ action: 'update', resource: 'Addon' },
			],
		},
	},
] as RouteConfig[]

export default routes
